var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDropdown = function SvgIconDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61042 4.58706C5.4118 4.80775 5.06574 4.80775 4.86712 4.58706L1.4898 0.834483C1.20022 0.512722 1.42857 2.27173e-07 1.86145 2.65017e-07L8.61609 8.55526e-07C9.04897 8.9337e-07 9.27732 0.512722 8.98774 0.834483L5.61042 4.58706Z",
    fill: "#2F2F4B"
  })));
};
export default SvgIconDropdown;